import { BaseEntity } from "../base/BaseEntity";

export class Comment extends BaseEntity  {
    id: string;
    parentId: string;
    userId:string;
    userName: string;
    note: string;
    constructor(parentId:string=null) {
      super();
      this.note = '';
      this.parentId = parentId;
    }
  }
  